const PlatformList = [
  {
    image: 'DexIcon',
    title: 'SparkSwap DEX',
    description: 'Instantly swap multiple cryptocurrencies in a trustless and decentralized manner. Earn from the transaction fees when the user provides liquidity. ',
    link: 'https://sparkswap.finance/#/swap',
  },
  {
    image: 'AnalyticsIcon',
    title: 'SparkSwap Analytics and Info',
    description:
      "Check the stats of all assets, pairs and liquidity pools available in the SparkSwap DEX. ",
      link: 'https://sparkswap.info/#/home',
  },
  {
    image: 'PerpetualIcon',
    title: 'SparkSwap Futures',
    description:
      "Empowers you with a state-of-the-art platform. Dive into perpetual futures, harness volatility, and uncover new profit-making possibilities. ",
      link: 'https://perp.sparkswap.finance',
  },
  {
    image: 'MultisenderIcon',
    title: 'Multisender',
    description:
      "Send tokens to thousands of addresses in just a few seconds. Use your SRKb and SFUEL tokens for discounted rates. ",
    link: 'https://multisend.sparkswap.finance/#/',
  },
  {
    image: 'PoolsIcon',
    title: 'SparkPool | Pools',
    description:
      "Pool-based staking is the simplest way to earn free tokens on SparkSwap. You stake and you earn token rewards, simple as that. ",
    link: 'https://app.sparkswap.finance/#/pools',
  },
  {
    image: 'FarmsIcon',
    title: 'SparkPool | Farms',
    description: "Staking that rewards liquidity providers with SRK or SFUEL tokens. Add liquidity to a pair, earn Spark-LP tokens, stake and earn token rewards.",
    link: 'https://app.sparkswap.finance/#/farms',
  },
  {
    image: 'BridgeIcon',
    title: 'SparkBridge',
    description: 'Cross-blockchain bridging for transferring Ethereum ERC-20 SRK to Binance Smart Chain as BEP-20 SRKb tokens and vice versa. SparkBridge will also support other token on future updates.',
    link: 'https://app.sparkswap.finance/#/bridge',
  },
  {
    image: 'LaunchIcon',
    title: 'SparkLaunch IDO Launchpad Platform',
    description: 'Discover the hottest and latest projects launching in the blockchain world. Participate now and be onboarded and go to the moon! ',
    link: 'https://app.sparkswap.finance/#/launch',
  },
  {
    image: 'NftIcon',
    title: 'SparkNFT Platform',
    description: 'SparkNFT enables enthusiasts, collectors, artists, fans, or anyone to buy, sell, and even manage their NFTs on the BSC network in a robust platform.',
    link: 'https://app.sparkswap.finance/#/nft',
  },
  {
    image: 'RewardsIcon',
    title: 'SparkRewards',
    description: 'Hub for the next-level airdrops. Empowering creators and communities to launch engaging campaigns with ease. Experience the future of token distribution with multisender and self-claim airdrops on SparkRewards!',
    link: 'https://rewards.sparkswap.finance/',
  },
  {
    image: 'DaoIcon',
    title: 'SparkSwap DAO',
    description: 'Vote and decide the future of SparkSwap DeFi Platform! ',
  },
]

export default PlatformList
